// extracted by mini-css-extract-plugin
export default {"button":"em-z","reviewSort":"fm-z"};